import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import AppUtils from '../../../utils/AppUtils'
import AppConstants from '../../../utils/AppConstants'
import ProductForm from '../../../components/forms/ProductForm'
import Popup from '../../../components/elements/Popup'

import Types from '../../../actions/Types'
import PostAction from '../../../actions/products/PostAction'
import ListOwnersAction from '../../../actions/owners/ListAction'
import ClearErrorAction from '../../../actions/app/ClearErrorAction'

class CreateProductPopup extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      submit: null
    }

    // Bind events
    this.submit = this.submit.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  componentDidMount() {
    this.props.fetchOwners()
  }

  componentDidUpdate(prevProps, prevState) {
    // When successful, close popup
    if (
      prevProps.isSaving
      &&
      !this.props.isSaving
      &&
      !this.props.error
    ) {
      AppUtils.setStatus(AppConstants.STATUS.TYPE.SUCCESS, 'Matériel ajouté.')
      this.props.onClose(true)
    }
  }

  submit() {
    if (_.isFunction(this.state.submit)) {
      this.state.submit()
    }
  }

  onSubmit(data) {
    this.props.post(data)
  }

  render() {
    return (
      <Popup
        header='Créer un matériel'
        body={
          <ProductForm
            isFull={false}
            category={this.props.category}
            data={undefined}
            onSubmit={this.onSubmit}
            onClearError={this.props.clearError}
            isLoading={false}
            isSaving={this.props.isSaving}
            registerSubmit={(submit) => { this.setState({ submit })}}
            error={this.props.error}
            ownersList={this.props.ownersList}
            ownersIsFetching={this.props.ownersIsFetching}
            diametersList={undefined}
            diametersIsFetching={undefined}
            batteriesList={undefined}
            batteriesIsFetching={undefined}
          />
        }
        footer={[
          {
            type: Popup.BUTTONTYPE.CLOSE,
            title: 'Annuler',
            color: 'red',
            icon: 'close',
            basic: true,
            onClick: () => this.props.onClose(false)
          },
          {
            type: Popup.BUTTONTYPE.SUBMIT,
            title: 'Créer',
            color: 'green',
            icon: 'checkmark',
            onClick: this.submit
          }
        ]}
        isSaving={this.props.isSaving}
      />
    )
  }
}

CreateProductPopup.propTypes = {
  // Properties
  category: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,

  // Redux State
  isSaving: PropTypes.bool.isRequired,
  error: PropTypes.object,
  ownersList: PropTypes.array,
  ownersIsFetching: PropTypes.bool.isRequired,

  // Redux Actions
  post: PropTypes.func.isRequired,
  fetchOwners: PropTypes.func.isRequired,
  clearError: PropTypes.func.isRequired
}

export default connect(
  (state) => ({
    isSaving: state.entities.products.post.isFetching,
    error: state.entities.products.post.error,
    ownersList: state.entities.owners.list.data,
    ownersIsFetching: state.entities.owners.list.isFetching
  }),
  (dispatch) => ({
    post: (data) => (dispatch(PostAction({ data }))),
    fetchOwners: () => (dispatch(ListOwnersAction({}))),
    clearError: () => (dispatch(ClearErrorAction(Types.PRODUCTS.POST)))
  })
)(CreateProductPopup)



// WEBPACK FOOTER //
// ./src/containers/popups/products/CreateProductPopup.js